import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/AppLayout';
import Header from './Header';
import TabContent from './TabContent';
import Tabs from './Tabs';
import usePolicyDetailsFunctions from './usePolicyDetailsFunctions';

const PolicyDetailScreen = () => {
  const { t } = useTranslation();
  const { S, TABS, history, policy, loading, error, activeTab, setActiveTab, fetchPolicy, patchPolicy, status, statusCfg, policyNumber, lob, holderName, annualPremium } =
    usePolicyDetailsFunctions();

  if (loading) {
    return (
      <AppLayout>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
          <div style={{ color: S.textMuted, fontSize: 15 }}>{t('screens.policiesScreen.detail.loading')}</div>
        </div>
      </AppLayout>
    );
  }

  if (error || !policy) {
    return (
      <AppLayout>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 16 }}>
          <div style={{ color: '#ef4444', fontWeight: 600, fontSize: 16 }}>{error || t('screens.policiesScreen.detail.notFound')}</div>
          <button
            onClick={fetchPolicy}
            style={{ padding: '10px 24px', background: S.burgundy, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}
          >
            {t('screens.policiesScreen.detail.retry')}
          </button>
          <button
            onClick={() => history.push('/policies')}
            style={{ padding: '8px 20px', background: S.bgCard, border: `1px solid ${S.borderLight}`, borderRadius: 8, cursor: 'pointer', color: S.textSecondary }}
          >
            {t('screens.policiesScreen.detail.backToPolicies')}
          </button>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {/* Header */}
        <Header
          history={history}
          policyNumber={policyNumber}
          holderName={holderName}
          status={status}
          statusCfg={statusCfg}
          policy={policy}
          S={S}
          lob={lob}
          annualPremium={annualPremium}
          onPatch={patchPolicy}
        />

        {/* Tabs */}
        <Tabs TABS={TABS} activeTab={activeTab} setActiveTab={setActiveTab} S={S} />

        {/* Tab content */}
        <TabContent history={history} S={S} activeTab={activeTab} policy={policy} lob={lob} />
      </div>
    </AppLayout>
  );
};

export default PolicyDetailScreen;
